import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const LEAGUES = [
  { name: 'Premier League', country: 'England', emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  { name: 'Championship', country: 'England', emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  { name: 'La Liga', country: 'Spain', emoji: '🇪🇸' },
  { name: 'Bundesliga', country: 'Germany', emoji: '🇩🇪' },
  { name: 'Serie A', country: 'Italy', emoji: '🇮🇹' },
  { name: 'Ligue 1', country: 'France', emoji: '🇫🇷' },
]

export function LeagueBadges() {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section ref={ref} className="leagues-section">
      <motion.h2
        className="leagues-title"
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        Six Major Leagues. Complete Coverage.
      </motion.h2>

      <div className="leagues-grid">
        {LEAGUES.map((league, index) => (
          <motion.div
            key={league.name}
            className="league-badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{
              duration: 0.4,
              delay: index * 0.1,
              type: 'spring',
              stiffness: 200,
            }}
            whileHover={{ scale: 1.05 }}
          >
            <span className="league-badge-icon">{league.emoji}</span>
            <span className="league-badge-name">{league.name}</span>
            <span className="league-badge-country">{league.country}</span>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
